import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { RouteList } from "../../Component/RoutesList";
import activeDash from "../../Assets/Image/sidebar/dashboard_active.webp";
import activeCat from "../../Assets/Image/sidebar/CategoryActive.png";
import activeUser from "../../Assets/Image/sidebar/user.webp";
import activeAdminRole from "../../Assets/Image/sidebar/adminroles_active.webp";
import activeAnalytics from "../../Assets/Image/sidebar/analytics_active.webp";
import activeBusiness from "../../Assets/Image/sidebar/buisness_active.webp";
// import activeComplain from "../../Assets/Image/sidebar/complaint_active.webp";
import activeContent from "../../Assets/Image/sidebar/content_active.webp";
import activeHelp from "../../Assets/Image/sidebar/help_active.webp";
import activeList from "../../Assets/Image/sidebar/list_active.webp";
import activeReport from "../../Assets/Image/sidebar/report_active.webp";
import activeReview from "../../Assets/Image/sidebar/review_active.webp";
// import activeSubscription from "../../Assets/Image/sidebar/subscriptions_active.webp";
import user from "../../Assets/Image/sidebar/User_active.webp";
import cat from "../../Assets/Image/sidebar/Category.png";
import Dash from "../../Assets/Image/sidebar/dashboard.webp";
// import subscription from "../../Assets/Image/sidebar/subscriptions.webp";
import review from "../../Assets/Image/sidebar/review.webp";
import report from "../../Assets/Image/sidebar/report.webp";
import list from "../../Assets/Image/sidebar/list.webp";
import help from "../../Assets/Image/sidebar/help.webp";
import content from "../../Assets/Image/sidebar/content.webp";
// import complaint from "../../Assets/Image/sidebar/complaint.webp";
import business from "../../Assets/Image/sidebar/business.webp";
// import analytics from "../../Assets/Image/sidebar/analytics.webp";
import adminroles from "../../Assets/Image/sidebar/adminroles.webp";
import noti from "../../Assets/Image/sidebar/Bell.png";
import notiA from "../../Assets/Image/sidebar/Bell_light.png";
import analyticsA from "../../Assets/Image/sidebar/ACTAnalytics & Reporting.png";
import analytics from "../../Assets/Image/sidebar/Analytics & Reporting.png";
import businessModeration from "../../Assets/Image/sidebar/Business Moderation.png";
import businessModerationA from "../../Assets/Image/sidebar/ACTBusiness Moderation.png";
import CommunityChat from "../../Assets/Image/sidebar/Community Chat Management.png";
import CommunityChatA from "../../Assets/Image/sidebar/ACTCommunity Chat Management.png";
import Financial from "../../Assets/Image/sidebar/Financial Management.png";
import FinancialA from "../../Assets/Image/sidebar/ACTFinancial Management.png";
import reports from "../../Assets/Image/sidebar/Reports & Logs.png";
import reportsA from "../../Assets/Image/sidebar/ACTReports & Logs.png";
import chat from "../../Assets/Image/sidebar/Chat.png";
import chatActive from "../../Assets/Image/sidebar/Chat Active.png";
import chatMD from "../../Assets/Image/sidebar/Category.webp";
import chatMDActive from "../../Assets/Image/sidebar/Category_active.webp";
import CommMDActive from "../../Assets/Image/sidebar/Community MD Active.png";
import CommMD from "../../Assets/Image/sidebar/Community MD.png";
import Policy from "../../Assets/Image/sidebar/Policy.png";
import PolicyActive from "../../Assets/Image/sidebar/PolicyActive.png";


const SideMenubar = () => {
  const location = useLocation();
  const userRoles =
    JSON.parse(localStorage.getItem("Megalopolist-userData-roles")) || [];
  const SideMenuList = [
    {
      id: 1,
      name: "Dashboard Overview",
      link: RouteList.dashboard,
      icon: Dash,
      active: activeDash,
    },
    {
      id: 2,
      name: "User Management",
      link: RouteList.user,
      icon: user,
      active: activeUser,
    },
    {
      id: 3,
      name: "Listings Management ",
      link: RouteList.list,
      icon: list,
      active: activeList,
    },
    {
      id: 4,
      name: "Business Management",
      link: RouteList.business,
      icon: business,
      active: activeBusiness,
    },
    {
      id: 5,
      name: "Business Moderation",
      link: RouteList.businessModeration,
      icon: businessModeration,
      active: businessModerationA,
    },
    {
      id: 6,
      name: "Content Moderation",
      link: RouteList.report,
      icon: content,
      active: activeContent,
    },

    {
      id: 7,
      name: "Chat Management",
      link: RouteList.ChatManagement,
      icon: chat,
      active: chatActive,
    },
    {
      id: 8,
      name: "Chat Moderation",
      link: RouteList.ChatModeration,
      icon: chatMD,
      active: chatMDActive,
    },
    {
      id: 9,
      name: "Community Chat Management ",
      link: RouteList.CommunityManagement,
      icon: CommunityChat,
      active: CommunityChatA,
    },
    {
      id: 10,
      name: "Community Chat Moderation",
      link: RouteList.CommunityModeration,
      icon: CommMD,
      active: CommMDActive,
    },

    {
      id: 11,
      name: "Financial Management",
      link: RouteList.financial,
      icon: Financial,
      active: FinancialA,
    },

    {
      id: 12,
      name: "Notifications Management",
      link: RouteList?.notification,
      icon: noti,
      active: notiA,
    },
    {
      id: 13,
      name: "Reports & Logs",
      link: RouteList.reportsAndLogs,
      icon: reports,
      active: reportsA,
    },
    {
      id: 14,
      name: "Category",
      link: RouteList.category,
      icon: cat,
      active: activeCat,
    },
    {
      id: 15,
      name: "Admin Role",
      link: RouteList.adminRole,
      icon: adminroles,
      active: activeAdminRole,
    },

    {
      id: 16,
      name: "Review",
      link: RouteList.review,
      icon: review,
      active: activeReview,
    },

    {
      id: 17,
      name: "Help & Support",
      link: RouteList.help,
      icon: help,
      active: activeHelp,
    },
    {
      id: 18,
      name: "Legal Policy Management",
      link: RouteList.content,
      icon: Policy,
      active: PolicyActive,
    },
  ];

  return (
    <List
      sx={{
        gap: 0.9,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {SideMenuList.filter((menuItem) =>
        userRoles.some(
          (role) => role.id === menuItem.id && role.admin_user_id
        )
      ).map(({ name, link, icon, active }, index) => {
        const isActive = location.pathname === link;
        const iconColor = isActive ? "#FFFFFF" : "#00000099";
        const iconImage = isActive ? active : icon;

        return (
          <Link
            to={link}
            key={index}
            style={{
              textDecoration: "none",
              color: "#000000",
            }}
          >
            <ListItem
              key={name}
              disablePadding
              sx={{
                background: isActive ? "#FF602D" : "transparent",
                color: iconColor,
                "&:hover": {
                  outline: !isActive ? "1px solid #FF602D" : "none",
                  boxSizing: "border-box",
                  width: "100%",
                },
              }}
            >
              <ListItemButton
                sx={{
                  "& .MuiListItemIcon-root": {
                    minWidth: "55px",
                    pl: 1,
                  },
                  "& .MuiTypography-root": {
                    fontWeight: 600,
                  },
                }}
              >
                <ListItemIcon>
                  <img
                    src={iconImage}
                    style={{ height: "30px", width: "30px" }}
                    alt=""
                  />
                </ListItemIcon>
                <ListItemText sx={{ fontWeight: 600 }} primary={name} />
              </ListItemButton>
            </ListItem>
          </Link>
        );
      })}
    </List>
  );
};

export default SideMenubar;
